const info = {
    ZH: { //中文翻译
      checkResult:"校验查询结果",
      SVHC:'SVHC通报分析结果页面',
      customCheck:'\u81EA\u5B9A\u4E49\u6821\u9A8C\u89C4\u5219',
      Verification:"校验规则结果",
      Information:"本企业信息",
      SendSI:"发送状态信息",
      model:"组件单元",
    },
    EN: { //英文翻译
      checkResult:"Verification results",
      SVHC:'SVHC report analysis result page',
      customCheck:"User-defined rules",
      Verification:"Verification Rule Results",
      Information:"Information of our company",
      SendSI:"Send status information",
      model:"Module",
    }
  }
  export default info //需要暴露出去
  